export const initializeGoogleAnalytics = () => {
  // @ts-ignore
  window.dataLayer = window.dataLayer || [];
  function gtag(...args: any[]) {
    // @ts-ignore
    window.dataLayer.push(arguments);
  }
  gtag('js', new Date());
  gtag('config', 'G-KWG32HL2WD');
};